import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'lastPage'
})
export class LastPagePipe implements PipeTransform {

  transform(allItems: number, itemsPerPage: number): string {
    const add = allItems % itemsPerPage === 0 ? 0 : 1;
    return (Math.floor(allItems / itemsPerPage) + add).toString();
  }

}
